import Divider from "@assets/divider.svg";
import qrcode from "@assets/redants-qrcode.png";
import facebook from "@assets/share/facebook.svg";
import mail from "@assets/share/mail.svg";
import telegram from "@assets/share/tg.svg";
import tiktok from "@assets/share/tiktok.svg";
import youtube from "@assets/share/youtube.svg";
import Link from "@src/app/components/Link";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import Share from "@src/app/components/SocialMedia";

const mediaList = [
  {
    name: "facebook",
    url: "https://www.facebook.com/RedAnts.SG/",
    img: facebook,
  },
  {
    name: "telegram",
    url: "https://t.me/redantssg",
    img: telegram,
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/c/RedAntsSG",
    img: youtube,
  },
  {
    name: "tiktok",
    url: "https://www.tiktok.com/@redants.sg",
    img: tiktok,
  },
  {
    name: "mail",
    url: "mailto:antsinfo@redants.sg",
    img: mail,
  },
];

export const meta = () =>
  createMetaTags({
    title: "关于我们 | 红蚂蚁",
    description:
      "《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
    canonical: "https://www.redants.sg/about-us",
  });

export default function AboutUsPage() {
  return (
    <main className="box-border bg-secondary lg:px-[24px]">
      <div className="m-auto box-border px-[12px] py-[16px] text-secondary xs:max-w-full lg:max-w-[944px] xxl:max-w-[800px]">
        <h1 className="mb-[12px] text-header-1">关于我们</h1>
        <p className="mb-[16px] text-body-1">
          红蚂蚁扎根新加坡，以生动的笔调呈现海内外新闻。
        </p>
        <p className="mb-[16px] text-body-1">
          本网站取名红蚂蚁，旨在学习蚂蚁机灵的脑袋、灵活的身形和咬人会疼的本领。
        </p>
        <p className="mb-[16px] text-body-1">
          蚂蚁之所以“红”
          ，是因为立足于“小红点”新加坡，触角伸向区域与世界，随意钻、认真咬。
        </p>
        <p className="mb-[12px] text-body-1">
          RedAnts is managed by Red Anthill Ventures Pte.Ltd, a wholly-owned
          subsidiary under SPH Media.
        </p>
        <img
          src={Divider}
          className="mb-[12px] box-border w-full px-[12px] py-[16px]"
          alt="line"
        />
        <h2 className="mb-[12px] text-header-1">联系我们</h2>
        <p className="mb-[12px] text-body-1">
          想联系我们说说话或者反馈意见，可以发电邮至：
          <Link
            to="mailto:antsinfo@redants.sg"
            className="text-link-primary underline hover:text-link-primary-hover"
          >
            antsinfo@redants.sg
          </Link>
        </p>
        <img
          src={Divider}
          className="mb-[12px] box-border w-full px-[12px] py-[16px]"
          alt="line"
        />
        <h2 className="mb-[12px] text-header-1">关注我们</h2>
        <p className="mb-[12px] text-body-1">
          想跟随红蚂蚁的脚步吗？可以选择以下几种途径：
        </p>
        <Share media={mediaList} className="mb-[12px] mr-[8px]" />
        <p className="mb-[12px] text-body-1">
          添加红蚂蚁为微信好友。扫描二维码或搜索微信账号。
        </p>
        <img src={qrcode} alt="qrcode" className="w-[180px]" />
        <p className="mt-[12px] text-body-1">微信号: sgredants</p>
      </div>
    </main>
  );
}
